import {isElectron as checkIfElectron} from '@toolify/client/src/modules/electron/singletons/isElectron'

export function useIsElectron() {
  const isElectron = checkIfElectron()
  return {
    isElectron,
  }
}
